import { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Tabs as AntTabs } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { TabsProps, TabPaneProps } from './types';

enum TabNavHeight {
  large = 60,
  middle = 43,
  small = 35,
}

export const GlobalStyle = createGlobalStyle`
  .ant-tabs-dropdown-menu {
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 8px 40px #f2f3f4;
    font: var(--main-font);
    color: ${colors.gray900};
    padding: 0;
  }

  .ant-tabs-dropdown-menu-item {
    padding-top: 0;
    padding-bottom: 0;
    min-height: 40px;
    line-height: 40px;
    color: ${colors.gray900};
  }

  .ant-tabs-dropdown-menu-item:hover {
    background-color: #f7f9fe;
  }

  .ant-tabs-nav-more {
    transition: color 1.5ms ease;

    .anticon {
      display: flex;
      transition: transform 0.24s;
      font-size: 16px;
    }
  }

  .ant-tabs-dropdown-open,
  .ant-tabs-nav-more:hover {
    color: ${colors.blue500};

    .anticon {
      transform: rotate(180deg);
    }
  }
`;

export const Wrapper = styled<FC<TabsProps>>(AntTabs)`
  color: ${colors.gray900};
  line-height: 24px;

  .ant-tabs-tab {
    padding: 8px 16px 11px;
    height: ${props => TabNavHeight[props.size || 'middle']}px;

    &.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${colors.blue600};
    }

    &:hover {
      color: ${colors.blue500};
    }
  }

  &.ant-tabs-large .ant-tabs-tab {
    font-size: 14px;
    padding: 17px 16px 19px;
  }

  &.ant-tabs-small .ant-tabs-tab {
    padding: 4px 16px 7px;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }

  .ant-tabs-nav .ant-tabs-ink-bar {
    background-color: ${colors.blue600};
    border-radius: 16px 16px 0 0;
    height: 2px;
    bottom: 1px;
  }

  .ant-tabs-tab.ant-tabs-tab-disabled {
    color: ${colors.gray400};
  }
`;

export const TabPane = styled<FC<TabPaneProps>>(AntTabs.TabPane)``;
